import { render, staticRenderFns } from "./TransferInspectModal.vue?vue&type=template&id=010a30de&scoped=true&"
import script from "./TransferInspectModal.vue?vue&type=script&lang=ts&"
export * from "./TransferInspectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a30de",
  null
  
)

export default component.exports